import type {DragAndDropManager} from 'common/report/contexts/query-contexts/drag-and-drop';
import {contextify} from 'common/util/react';

const context = contextify<DragAndDropManager>();

export const DragAndDropManagerProvider = context.Provider;
export const DragAndDropManagerConsumer = context.Consumer;
export const useDragAndDropManager = context.hook;
